<template>
  <div class="flex flex-col justify-self-center justify-center gap-4 md:flex-row max-w-[1200px] px-4 mt-10 w-[100%]">
    <div class="flex flex-col gap-3 text-center md:text-left md:w-2/5 justify-center">
      <h2 class="text-ROJO_LEON font-bold text-lg md:text-3xl">
        {{ data.title }} <br />
        {{ data.titleEnd }}
      </h2>
      <p v-if="data.subtitle" class="text-ROJO_LEON font-bold md:text-2xl">
        {{ data.subtitle }}
      </p>
      <p class="font-bold">
        {{ data.description }}
      </p>

      <NuxtLink :to="data.to"
        class="bg-ROJO_LEON text-white mx-auto md:mx-0 w-2/3 rounded-lg py-2 px-4 font-bold hover:bg-GRIS_CLARO_COMPLEMENTARIO_2 transition hover:text-ROJO_LEON my-3 text-center">
        {{ data.buttonText }}
      </NuxtLink>
    </div>
    <div class="flex justify-end md:w-3/5">
      <img class="block" :src="data.image" alt="contenido-imagen" />
    </div>
  </div>
</template>

<script setup>
import { ref, computed } from "vue";
import { NEGOCIOS } from "~/constants/negocios";

const modo_sistema = useState('modo_sistema');

const batteryData = {
  title: "ELEMENTOS FUNDAMENTALES",
  to: `/${NEGOCIOS.BATERIAS}/parts`,
  titleEnd: "DE UNA BATERÍA",
  subtitle: "Exploración de los componentes esenciales",
  description:
    "Las baterías son dispositivos que convierten energía química en energía eléctrica, lo que las convierte en componentes esenciales para el vehículo. Aquí exploramos los elementos fundamentales que componen una batería.",
  buttonText: "Aprender Más",
  image: "/img/home/battery/battery-que-hay.png",
};

const tireData = {
  to: `/${NEGOCIOS.NEUMATICOS}/detail`,
  title: "¿QUÉ HAY DENTRO DE",
  titleEnd: "UN NEUMÁTICO?",
  subtitle: "",
  description:
    "El neumático generalmente se compone de: banda de rodadura, capas, costado (o flanco), capa interior, hombro, relleno de talón y un cuerpo de cuerda.",
  buttonText: "Aprender Más",
  image: "/img/home/neumatico-que-hay.webp",
};

const data = computed(() => {
  if (modo_sistema.value == NEGOCIOS.BATERIAS) {
    return batteryData;
  } else {
    return tireData;
  }
});

</script>
